export default __webpack_public_path__ + "static/media/032.a1d21d25.jpg";